import { render, staticRenderFns } from "./ProductsChart.vue?vue&type=template&id=60156e48&scoped=true&"
import script from "./ProductsChart.vue?vue&type=script&lang=js&"
export * from "./ProductsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60156e48",
  null
  
)

export default component.exports